"use client";

import Link from "next/link";
import type { RentBannerWithCity } from "@/lib/fleet-server";
import { bannerImageSrc, buildBannerLink, trackBannerClick, bannerKind } from "@/lib/banners";
import { track } from "@/lib/metrika";
import { useSearch } from "./SearchProvider";

// Карточка баннера в сетке авто (как PromoCard Солнышко): фон-картинка +
// заголовок цветом text_color снизу. Клик → страница города баннера с
// пресетами (buildBannerLink) + трекинг. Промо-баннер ведёт на /promo и несёт
// текущие даты поиска (он показывается только в выдаче свободных по датам).
export default function BannerCard({ banner }: { banner: RentBannerWithCity }) {
  const { lastSearch } = useSearch();
  let href = buildBannerLink(banner);
  if (bannerKind(banner) === "promo" && lastSearch) {
    const d = new URLSearchParams({
      start: lastSearch.startDate, end: lastSearch.endDate,
      start_time: lastSearch.startTime, end_time: lastSearch.endTime,
      days: String(lastSearch.days),
    });
    href += (href.includes("?") ? "&" : "?") + d.toString();
  }
  const img = bannerImageSrc(banner.image);
  const title = (banner.title_ru || "").trim();
  const external = /^https?:\/\//i.test(href);
  return (
    <Link
      href={href}
      onClick={() => { track("banner_click", { city: banner.slug }); trackBannerClick(banner); }}
      {...(external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      className="group relative flex h-full min-h-[280px] flex-col justify-end overflow-hidden rounded-2xl shadow-[0_4px_12.5px_rgba(0,0,0,0.05)] transition hover:shadow-[var(--shadow-card-hover)]"
      style={{
        backgroundImage: img ? `url(${img})` : "linear-gradient(135deg,#0039A6,#1e63d8)",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {title && (
        <span
          className="relative whitespace-pre-line p-5 text-[24px] font-bold leading-tight sm:text-[26px]"
          style={{ color: banner.text_color || "#FFFFFF", textShadow: "0 2px 12px rgba(0,0,0,0.35)" }}
        >
          {title}
        </span>
      )}
    </Link>
  );
}
